<template>
  <div class="bootstrap-wrapper">
    <div class="container">
      <DirPath :path="['Reportes', 'Plan de lectura complementaria']" />
      <HeaderView v-bind="headerData" />

      <ReportsConfig />
      <template v-if="reports.school && reports.course">
        <template v-if="showData && data">
          <div class="row col-12 my-4">
            <router-link
              :to="'/dashboard/books'"
              v-slot="{ href, route, navigate }"
            >
              <button class="button primary" :href="href" @click="navigate">
                Asignar un nuevo libro
              </button>
            </router-link>
          </div>

          <ul class="nav nav-tabs nav-fill ml-0" id="myTabMD" role="tablist">
            <li
              class="nav-item"
              v-for="assignment of data.monthAssignments"
              :key="assignment.book.id"
            >
              <a
                :class="
                  `nav-link ${
                    currentAssignment.book.id === assignment.book.id
                      ? 'active'
                      : ''
                  }`
                "
                :id="`assignment_${assignment.book.id}-tab`"
                data-toggle="tab"
                :href="`#assignment_${assignment.book.id}`"
                role="tab"
                aria-controls="assignment"
                aria-selected="true"
                @click="currentAssignment = assignment"
                >{{ assignment.book.title }}</a
              >
            </li>
          </ul>

          <div class="tab-content pt-4">
            <div class="row col-12 mb-3">
              <span class="text-barlow-condensed subtitle text-dark">
                Asignación obligatoria desde
                {{ currentAssignment.startingDate }} hasta
                {{ currentAssignment.evaluationDate }}
              </span>
            </div>
            <div
              class="row tab-pane fade show active"
              :id="`#assignment_${currentAssignment.book.id}`"
              role="tabpanel"
              aria-labelledby="assignment-tab"
            >
              <div class="col-md-8 mb-3 pr-0">
                <div class="row col-12 mr-0 pr-0">
                  <div class="row">
                    <div class="col-md-6 mt-2">
                      <img
                        :src="
                          `https://assets.beereaders.com/lbr/image/${currentAssignment.book.resourceDir}/cover_medium.jpg`
                        "
                        alt=""
                      />
                    </div>
                    <div class="col-md-6">
                      <div class="row col-12">
                        <span class="text-barlow-condensed text-primary h1">
                          {{ currentAssignment.book.title }}
                        </span>
                      </div>

                      <div class="row col-12">
                        <p class="text-justify text-gray">
                          {{ currentAssignment.book.bookAbstract }}
                        </p>
                      </div>
                      <div class="row col-12">
                        <button
                          class="button secondary"
                          @click="showModal.ReadingComprehension = true"
                        >
                          Ver resultados de comprensión Lectora
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="elevation-1 radius-20 pt-3 pl-3">
                  <div class="col-12">
                    <span class="text-barlow-condensed subtitle text-dark">
                      Porcentaje general de avance:
                    </span>
                  </div>
                  <div class="col-12 text-center">
                    <span
                      class="text-barlow-condensed text-primary h1-xl mx-auto"
                    >
                      {{ currentAssignment.porcentajeAvance }}%
                    </span>
                  </div>
                  <div class="col-12 text-center">
                    <button
                      class="button secondary mx-auto"
                      @click="showModal.GeneralProgress = true"
                    >
                      Ver más detalles
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row elevation-1 radius-20 p-4 mt-4 mx-0">
            <div class="col-12 mb-3 text-center">
              <span class="text-barlow-condensed subtitle text-dark">
                Siguiente Libro Obligatorio Asignado del Próximo Mes
              </span>
            </div>
            <template v-if="firstAssignmentNextMonth">
              <div class="col-12">
                <div class="row col-12">
                  <span class="text-barlow-condensed text-primary h1">
                    {{ firstAssignmentNextMonth.title }}
                  </span>
                </div>
              </div>
              <div class="col-12">
                <p class="text-justify text-gray">
                  {{ firstAssignmentNextMonth.bookAbstract }}
                </p>
              </div>
            </template>
            <template v-else>
              <div class="col-12 text-center">
                <span class="text-barlow-condensed text-primary">
                  No hay libro asignado para el próximo mes
                </span>
              </div>
              <div class="col-12 text-center">
                <router-link
                  :to="'/dashboard/books'"
                  v-slot="{ href, route, navigate }"
                >
                  <button
                    class="button primary mx-auto mt-3"
                    :href="href"
                    @click="navigate"
                  >
                    Asignar un nuevo libro
                  </button>
                </router-link>
              </div>
            </template>
          </div>

          <div class="row mt-4 justify-content-between">
            <div class="elevation-1 radius-20 pt-3 my-4">
              <div class="col-12">
                <span class="text-barlow-condensed subtitle text-dark">
                  Total Libros Por Gusto Propio Últimos 30 días
                </span>
              </div>
              <div class="col-12 text-center">
                <span class="text-barlow-condensed text-primary h1-xl mx-auto">
                  {{ data.bookCountGustoPropio }}
                </span>
              </div>
              <div class="col-12 text-center">
                <button
                  class="button secondary mx-auto"
                  @click="showModal.CurrentReadingBooks = true"
                >
                  Ver más detalles
                </button>
              </div>
            </div>
            <div class="elevation-1 radius-20 pt-3 my-4">
              <div class="col-12">
                <span class="text-barlow-condensed subtitle text-dark">
                  Promedio de Libros por Estudiante
                </span>
              </div>
              <div class="col-12 text-center">
                <span class="text-barlow-condensed text-primary h1-xl mx-auto">
                  {{ data.promedioLibroEstudiante }}
                </span>
              </div>
            </div>
          </div>

          <div>
            <GeneralProgress
              :data="currentAssignment.readers"
              v-if="showModal.GeneralProgress"
              @close="showModal.GeneralProgress = false"
            />
            <CurrentReadingBooks
              :data="data.bookListGustoPropio"
              v-if="showModal.CurrentReadingBooks"
              @close="showModal.CurrentReadingBooks = false"
            />
            <ReadingComprehension
              v-if="showModal.ReadingComprehension"
              :assignment="currentAssignment"
              @close="showModal.ReadingComprehension = false"
            />
          </div>
        </template>
        <template v-if="showData && error">
          <div class="row">
            <div class="col text-center text-gray">
              {{ error }}
            </div>
          </div>
        </template>
        <div class="row" v-if="showSpinner">
          <div class="col text-center text-gray">
            Cargando...
          </div>
        </div>
      </template>
      <div class="row">
        <FooterComponent />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DirPath from "@/components/DirPath";
import FooterComponent from "@/components/Footer";
import GeneralProgress from "@/components/readingPlan/GeneralProgress";
import CurrentReadingBooks from "@/components/readingPlan/CurrentReadingBooks";
import ReadingComprehension from "@/components/readingPlan/ReadingComprehension";
import HeaderView from "@/components/HeaderView";
import ReportsConfig from "@/components/ReportsConfig";

export default {
  name: "readingPlan",
  components: {
    DirPath,
    FooterComponent,
    GeneralProgress,
    CurrentReadingBooks,
    HeaderView,
    ReportsConfig,
    ReadingComprehension,
  },
  data() {
    let { secCol } = this.$store.getters;

    return {
      firstAssignmentNextMonth: null,
      currentAssignment: null,
      showData: false,
      showSpinner: false,
      headerData: {
        title: "Plan de lectura complementaria",
        subTitle: "",
        body:
          "Asigna libros y revisa los resultados de tus estudiantes con los libros que están leyendo con nosotros",
        img: require("@/assets/images/Componente 34 – 1.svg"),
      },
      secCol,
      showModal: {
        GeneralProgress: false,
        CurrentReadingBooks: false,
        ReadingComprehension: false,
      },
      data: null,
      error: "",
    };
  },
  computed: {
    ...mapState(["dataUrl", "reports"]),
  },
  watch: {
    "reports.course"() {
      if (this.reports.course) this.getReportData();
    },
  },
  methods: {
    async getReportData() {
      this.showData = false;
      this.showSpinner = true;
      this.data = null;
      this.error = "";

      let apiUrl = `${this.dataUrl}/courseBook/getProgressByCourseId?courseId=${this.reports.course}`;

      try {
        let { data } = await this.axios.get(apiUrl);

        this.showData = true;

        if (data.status.name.toLocaleLowerCase() == "error") {
          if (data.content) {
            this.error = data.content;
          } else {
            this.$notify({
              title: ["Ocurrió un error"],
              type: "danger",
            });
          }
        } else {
          this.data = data.content;
          this.currentAssignment = this.data.monthAssignments[0];
          this.firstAssignmentNextMonth = this.data.nextMonthAssingments[0];
        }
      } catch {
        this.$notify({
          title: ["Ocurrió un error"],
          type: "danger",
        });
      } finally {
        this.showSpinner = false;
      }
    },
  },
  mounted() {
    if (this.reports.course) this.getReportData();
  },
};
</script>

<style lang="scss" scoped>
p {
  line-height: 20px !important;
}

img {
  width: 100%;
  height: 100%;
}

// tabs
.nav-tabs .nav-link {
  border: none;
  color: #ffc700;
  font-weight: bolder;
}

.nav-tabs .nav-link.active {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  font-weight: bolder;
  color: #fff;
  box-shadow: 0 2px 6px 2px rgba(194, 194, 194, 0.7);
  background-color: #ffc700;
  border-color: transparent;
}
</style>
